import React, { useState, useEffect } from "react";
import Select from "react-select";

const MultiSelectAll = ({
  options = [],
  selectedOptions = [],
  setSelectedOptions,
}) => {
  const allOption = { label: "Select All", value: "*" };

  const isAllSelected = selectedOptions.length === options.length;

  // Handles the selection change
  const handleChange = (selected) => {
    if (!selected || selected.length === 0) {
      setSelectedOptions([]);
    } else if (selected.some((option) => option.value === "*")) {
      if (isAllSelected) {
        setSelectedOptions([]);
      } else {
        setSelectedOptions(options);
      }
    } else {
      setSelectedOptions(selected);
    }
  };

  // Checkbox component inside options
  const CustomOption = ({ data, innerRef, innerProps }) => {
    const isChecked =
      data.value === "*"
        ? isAllSelected
        : selectedOptions.some((opt) => opt.value === data.value);

    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{ display: "flex", alignItems: "center", padding: "8px" }}
      >
        <input
          type="checkbox"
          checked={isChecked}
          readOnly
          style={{ marginRight: "10px" }}
        />
        {data.image && (
          <img
            src={data.image}
            alt={data.label}
            style={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              marginRight: 10,
            }}
          />
        )}
        {data.label}
      </div>
    );
  };

  // Display "Select All" in input when all selected
  const displayValue = isAllSelected ? [allOption] : selectedOptions;
  return (
    <Select
      options={[allOption, ...options]}
      value={displayValue}
      onChange={handleChange}
      isMulti
      placeholder="Select Users"
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      components={{ Option: CustomOption }}
      getOptionLabel={(e) =>
        e.value === "*" && isAllSelected ? "Select All" : e.label
      }
    />
  );
};

export default MultiSelectAll;
